const normalizedId = (value) => {
  const id = String(value || "").trim();
  return id || null;
};

export const draftOverlayAutoSelection = ({
  draftId,
  lastAutoSelectedDraftId,
} = {}) => {
  const normalizedDraftId = normalizedId(draftId);
  const normalizedLastId = normalizedId(lastAutoSelectedDraftId);

  return {
    draftId: normalizedDraftId,
    shouldAutoSelect: Boolean(
      normalizedDraftId && normalizedDraftId !== normalizedLastId
    ),
    nextLastAutoSelectedDraftId: normalizedDraftId,
  };
};
